"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepairOptions = exports.InstallFamiliarizeOptions = exports.ApprovalStatus = exports.UserStatus = exports.Severity = exports.LicenseType = exports.LicenseDesignation = exports.LicenseOption = exports.DBAction = exports.WeightUnit = exports.FrontendProfileTab = exports.FrontendTestOptionTab = exports.FrontendContentPage = exports.AdminViewOrderStatus = exports.OrderStatus = exports.TestStatus = exports.FrontendTurnaroundTimeOptions = exports.TurnaroundTime = exports.TestPackages = exports.StaphylococcusCustomOption = exports.EColiCustomOption = exports.SalmonCustomOption = exports.BTGNCustomOption = exports.OtherSubMatrix = exports.AccessoriesSubMatrix = exports.PhysicalConcentrateExtractSubMatrix = exports.ChemicalConcentrateExtractSubMatrix = exports.TopicalsSubMatrix = exports.ConsumablesSubMatrix = exports.FreshCannabisSubMatrix = exports.HempSubMatrix = exports.DriedCannabisSubMatrix = exports.SampleMatrix = exports.InstrumentSource = exports.InstrumentCondition = exports.InstrumentType = exports.SampleCategory = exports.CurrentLoginPage = exports.UserType = exports.SPECIFICATION_ALLOWED_MIME_TYPES = exports.REPORT_ALLOWED_MIME_TYPES = exports.USER_SPECIFICATION_SIZE_LIMIT = exports.SPECIFICATION_FILE_SIZE_LIMIT = exports.REPORT_FILE_SIZE_LIMIT = exports.ONE_DAY_IN_SECONDS = exports.ONE_HOUR_IN_SECONDS = exports.ONE_DAY_IN_MS = exports.ONE_HOUR_IN_MS = exports.ONE_MINUTE_IN_MS = exports.ONE_SECOND_IN_MS = void 0;
exports.EngineerDocumentType = exports.PaymentStatus = exports.TaxOptions = exports.DiscountUnit = exports.WarrantyUnit = exports.OrderType = exports.OrderItemType = exports.ServicePackages = void 0;
exports.ONE_SECOND_IN_MS = 1000;
exports.ONE_MINUTE_IN_MS = exports.ONE_SECOND_IN_MS * 60;
exports.ONE_HOUR_IN_MS = exports.ONE_MINUTE_IN_MS * 60;
exports.ONE_DAY_IN_MS = exports.ONE_HOUR_IN_MS * 24;
exports.ONE_HOUR_IN_SECONDS = 3600;
exports.ONE_DAY_IN_SECONDS = 24 * exports.ONE_HOUR_IN_SECONDS;
exports.REPORT_FILE_SIZE_LIMIT = 1 * 1024 * 1024; // 1 MB
exports.SPECIFICATION_FILE_SIZE_LIMIT = 1 * 1024 * 1024; //1 MB
exports.USER_SPECIFICATION_SIZE_LIMIT = 50 * exports.SPECIFICATION_FILE_SIZE_LIMIT;
exports.REPORT_ALLOWED_MIME_TYPES = [
    "application/pdf", // PDF
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    "application/rtf", // RTF
    "text/plain", // TXT
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
    "text/csv", // CSV
    "text/html", // HTML
    "image/png", // PNG
    "image/jpeg", // JPEG
    "application/xml", // XML
];
exports.SPECIFICATION_ALLOWED_MIME_TYPES = [
    "application/pdf", // PDF
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    "application/rtf", // RTF
    "text/plain", // TXT
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
    "text/csv", // CSV
    "text/html", // HTML
    "image/png", // PNG
    "image/jpeg", // JPEG
    "application/xml", // XML
];
var UserType;
(function (UserType) {
    UserType["SYSTEM_ADMIN"] = "system admin";
    UserType["ADMIN"] = "admin";
    UserType["ENGINEER_ADMIN"] = "engineer admin";
    UserType["ENGINEER"] = "engineer";
    UserType["SHIPPING"] = "shipping";
    UserType["CLIENT"] = "client";
})(UserType || (exports.UserType = UserType = {}));
var CurrentLoginPage;
(function (CurrentLoginPage) {
    CurrentLoginPage["LOGIN"] = "login";
    CurrentLoginPage["FORGET_PASSWORD"] = "forget-password";
    CurrentLoginPage["FORGET_PASSWORD_SUCCESS"] = "forget-password-success";
})(CurrentLoginPage || (exports.CurrentLoginPage = CurrentLoginPage = {}));
var SampleCategory;
(function (SampleCategory) {
    SampleCategory["FLOWER"] = "Flower";
    SampleCategory["HYBRID"] = "Hybrid";
    SampleCategory["OIL"] = "Oil";
    SampleCategory["OTHER"] = "Other";
})(SampleCategory || (exports.SampleCategory = SampleCategory = {}));
var InstrumentType;
(function (InstrumentType) {
    InstrumentType["MASS_SPECTROMETRY"] = "Mass Spectrometry";
    InstrumentType["LIQUID_CHROMATOGRAPHY"] = "Liquid Chromatography";
    InstrumentType["GAS_CHROMATOGRAPHY"] = "Gas Chromatography";
    InstrumentType["SPECTROSCOPY_ELEMENTAL_ANALYSIS"] = "Spectroscopy & Elemental Analysis";
    InstrumentType["PARTS_ACCESSORIES"] = "Parts / Accessories";
    InstrumentType["NOT_SPECIFIED"] = "Not Specified";
})(InstrumentType || (exports.InstrumentType = InstrumentType = {}));
var InstrumentCondition;
(function (InstrumentCondition) {
    InstrumentCondition["LIKE_NEW"] = "Like-New";
    InstrumentCondition["REFURBISHED"] = "Refurbished";
    InstrumentCondition["TESTED_WORKING"] = "Tested Working";
    InstrumentCondition["USED"] = "Used";
    InstrumentCondition["AS_IS_CONDITION"] = "As-Is Condition";
})(InstrumentCondition || (exports.InstrumentCondition = InstrumentCondition = {}));
var InstrumentSource;
(function (InstrumentSource) {
    InstrumentSource["SPECTRALAB_SCIENTIFIC"] = "SpectraLab Scientific";
    InstrumentSource["OTHERS"] = "Others";
    InstrumentSource["ORIGINAL_MANUFACTURER"] = "Original Manufacturer";
})(InstrumentSource || (exports.InstrumentSource = InstrumentSource = {}));
var SampleMatrix;
(function (SampleMatrix) {
    SampleMatrix["DRIED_CANNABIS"] = "Dried Cannabis";
    SampleMatrix["HEMP"] = "Hemp";
    SampleMatrix["FRESH_CANNABIS"] = "Fresh Cannabis";
    SampleMatrix["CONSUMABLES"] = "Consumables";
    SampleMatrix["TOPICALS"] = "Topicals";
    SampleMatrix["CHEMICAL_CONCENTRATE_EXTRACT"] = "Chemically Concentrated Extracts";
    SampleMatrix["PHYSICAL_CONCENTRATE_EXTRACT"] = "Physically Concentrated Extracts";
    SampleMatrix["ACCESSORIES"] = "Accessories";
    SampleMatrix["OTHER"] = "Other";
})(SampleMatrix || (exports.SampleMatrix = SampleMatrix = {}));
var DriedCannabisSubMatrix;
(function (DriedCannabisSubMatrix) {
    DriedCannabisSubMatrix["FLOWER"] = "Dried Cannabis - Flower";
    DriedCannabisSubMatrix["INFUSED_FLOWER"] = "Dried Cannabis - Flower(infused)";
    DriedCannabisSubMatrix["MILLED"] = "Dried Cannabis - Milled";
    DriedCannabisSubMatrix["INFUSED_MILLED"] = "Dried Cannabis - Milled(infused)";
    DriedCannabisSubMatrix["PRE_ROLL"] = "Dried Cannabis - Pre-roll";
    DriedCannabisSubMatrix["INFUSED_PRE_ROLL"] = "Dried Cannabis - Pre-roll(infused)";
    DriedCannabisSubMatrix["SHAKE"] = "Dried Cannabis - Shake";
    DriedCannabisSubMatrix["TRIM"] = "Dried Cannabis - Trim";
})(DriedCannabisSubMatrix || (exports.DriedCannabisSubMatrix = DriedCannabisSubMatrix = {}));
var HempSubMatrix;
(function (HempSubMatrix) {
    HempSubMatrix["HEMP"] = "Hemp";
})(HempSubMatrix || (exports.HempSubMatrix = HempSubMatrix = {}));
var FreshCannabisSubMatrix;
(function (FreshCannabisSubMatrix) {
    FreshCannabisSubMatrix["FLOWER"] = "Fresh Cannabis - Flower";
    FreshCannabisSubMatrix["LEAF"] = "Fresh Cannabis - Leaf";
    FreshCannabisSubMatrix["ROOT"] = "Fresh Cannabis - Root";
})(FreshCannabisSubMatrix || (exports.FreshCannabisSubMatrix = FreshCannabisSubMatrix = {}));
var ConsumablesSubMatrix;
(function (ConsumablesSubMatrix) {
    ConsumablesSubMatrix["CANNABIS_OIL"] = "Consumables - Cannabis Oil";
    ConsumablesSubMatrix["SPRAYS"] = "Consumables - Sprays";
    ConsumablesSubMatrix["TINCTURES"] = "Consumables - Tinctures";
    ConsumablesSubMatrix["BEVERAGE"] = "Consumables - Beverage";
    ConsumablesSubMatrix["EDIBLES"] = "Consumables - Edibles";
})(ConsumablesSubMatrix || (exports.ConsumablesSubMatrix = ConsumablesSubMatrix = {}));
var TopicalsSubMatrix;
(function (TopicalsSubMatrix) {
    TopicalsSubMatrix["CREAMS"] = "Topicals - Creams";
    TopicalsSubMatrix["LINIMENTS"] = "Topicals - Liniments";
    TopicalsSubMatrix["SALVES"] = "Topicals - Salves";
})(TopicalsSubMatrix || (exports.TopicalsSubMatrix = TopicalsSubMatrix = {}));
var ChemicalConcentrateExtractSubMatrix;
(function (ChemicalConcentrateExtractSubMatrix) {
    ChemicalConcentrateExtractSubMatrix["BADDER"] = "Chemically Concentrated Extracts - Badder";
    ChemicalConcentrateExtractSubMatrix["LIVE_BADDER"] = "Chemically Concentrated Extracts - Badder(Live)";
    ChemicalConcentrateExtractSubMatrix["DIAMONDS"] = "Chemically Concentrated Extracts - Diamonds";
    ChemicalConcentrateExtractSubMatrix["DISTILLATE"] = "Chemically Concentrated Extracts - Distillate";
    ChemicalConcentrateExtractSubMatrix["HASH_OIL"] = "Chemically Concentrated Extracts - Hash Oil";
    ChemicalConcentrateExtractSubMatrix["ISOLATE"] = "Chemically Concentrated Extracts - Isolate";
    ChemicalConcentrateExtractSubMatrix["RESIN"] = "Chemically Concentrated Extracts - Resin";
    ChemicalConcentrateExtractSubMatrix["LIVE_RESIN"] = "Chemically Concentrated Extracts - Live Resin";
    ChemicalConcentrateExtractSubMatrix["SHATTER"] = "Chemically Concentrated Extracts - Shatter";
    ChemicalConcentrateExtractSubMatrix["WAX"] = "Chemically Concentrated Extracts - Wax";
})(ChemicalConcentrateExtractSubMatrix || (exports.ChemicalConcentrateExtractSubMatrix = ChemicalConcentrateExtractSubMatrix = {}));
var PhysicalConcentrateExtractSubMatrix;
(function (PhysicalConcentrateExtractSubMatrix) {
    PhysicalConcentrateExtractSubMatrix["HASH"] = "Physically Concentrated Extracts - Hash";
    PhysicalConcentrateExtractSubMatrix["DRY_SIFT_HASH"] = "Physically Concentrated Extracts - Hash(Dry Sift)";
    PhysicalConcentrateExtractSubMatrix["KIEF"] = "Physically Concentrated Extracts - Kief";
    PhysicalConcentrateExtractSubMatrix["PRESSED_KIEF"] = "Physically Concentrated Extracts - Kief(Pressed)";
    PhysicalConcentrateExtractSubMatrix["ROSIN"] = "Physically Concentrated Extracts - Rosin";
    PhysicalConcentrateExtractSubMatrix["FLOWER_ROSIN"] = "Physically Concentrated Extracts - Rosin(Flower)";
    PhysicalConcentrateExtractSubMatrix["HASH_ROSIN"] = "Physically Concentrated Extracts - Rosin(Hash)";
    PhysicalConcentrateExtractSubMatrix["LIVE_ROSIN"] = "Physically Concentrated Extracts - Rosin(Live)";
})(PhysicalConcentrateExtractSubMatrix || (exports.PhysicalConcentrateExtractSubMatrix = PhysicalConcentrateExtractSubMatrix = {}));
var AccessoriesSubMatrix;
(function (AccessoriesSubMatrix) {
    AccessoriesSubMatrix["ROLLING_PAPER"] = "Accessories - Rolling Paper";
})(AccessoriesSubMatrix || (exports.AccessoriesSubMatrix = AccessoriesSubMatrix = {}));
var OtherSubMatrix;
(function (OtherSubMatrix) {
    OtherSubMatrix["SOLID"] = "Other - Solid";
    OtherSubMatrix["INHALABLE"] = "Other - Inhalable";
})(OtherSubMatrix || (exports.OtherSubMatrix = OtherSubMatrix = {}));
// export enum OilSubMatrix {
// 	BADDER = "Badder",
// 	CONCENTRATE = "Concentrate",
// 	CREAM = "Cream",
// 	DIAMONDS = "Diamonds",
// 	DISTILLATE = "Distillate",
// 	EDIBLE_LIQUID = "Edible Liquid",
// 	EDIBLE_SOLID = "Edible Solid",
// 	EXTRACT = "Extract",
// 	FLOWER_ROSIN = "Flower Rosin",
// 	GRANULES = "Granules",
// 	HASH = "Hash",
// 	HASH_ROSIN = "Hash Rosin",
// 	ISOLATE = "Isolate",
// 	LIVE_BADDER = "Live Badder",
// 	LIVE_RESIN = "Live Resin",
// 	LIVE_ROSIN = "Live Rosin",
// 	LIVE_ROSIN_VAPE = "Live Rosin Vape",
// 	POWDER = "Powder",
// 	RESIN = "Resin",
// 	ROSIN = "Rosin",
// 	SAP = "Sap",
// 	SAUCE = "Sauce",
// 	SHATTER = "Shatter",
// 	SYRUP = "Syrup",
// 	TERPENES = "Terpenes",
// 	TINCTURE = "Tincture",
// 	TOPICAL = "Topical",
// 	VAPE = "Vape",
// 	WINTERIZED_OIL = "Winterized Oil",
// 	WINTERIZED_VAPE_OIL = "Winterized Vape Oil",
// 	OTHER_LIQUID = "Other (Liquid)",
// }
// export enum FlowerSubMatrix {
// 	DRIED_FLOWER = "Dried Flower",
// 	DRY_SIFT_HASH = "Dry Sift Hash",
// 	FRESH_FLOWER = "Fresh Flower",
// 	HASH = "Hash",
// 	HEMP = "Hemp",
// 	INFUSED_FLOWER = "Infused Flower",
// 	KIEF = "Kief",
// 	Leaf = "Leaf",
// 	MILLED_FLOWER = "Milled Flower",
// 	OTHER_INHALABLE = "Other (Inhalable)",
// 	OTHER_SOLID = "Other (Solid)",
// 	PREROLL = "Pre-roll",
// 	PRESSED_KIEF = "Pressed Kief",
// 	ROLLING_PAPER = "Rolling Paper",
// 	SHAKE = "Shake",
// 	TRIM = "Trim",
// }
var BTGNCustomOption;
(function (BTGNCustomOption) {
    BTGNCustomOption["OneGram"] = "1g";
    BTGNCustomOption["CFU"] = "CFU/g";
})(BTGNCustomOption || (exports.BTGNCustomOption = BTGNCustomOption = {}));
var SalmonCustomOption;
(function (SalmonCustomOption) {
    SalmonCustomOption["TwentyFiveGram"] = "25g";
    SalmonCustomOption["TenGram"] = "10g";
})(SalmonCustomOption || (exports.SalmonCustomOption = SalmonCustomOption = {}));
var EColiCustomOption;
(function (EColiCustomOption) {
    EColiCustomOption["OneGram"] = "1g";
    EColiCustomOption["TenGram"] = "10g";
})(EColiCustomOption || (exports.EColiCustomOption = EColiCustomOption = {}));
var StaphylococcusCustomOption;
(function (StaphylococcusCustomOption) {
    StaphylococcusCustomOption["OneGram"] = "1g";
    StaphylococcusCustomOption["TenGram"] = "10g";
})(StaphylococcusCustomOption || (exports.StaphylococcusCustomOption = StaphylococcusCustomOption = {}));
var TestPackages;
(function (TestPackages) {
    TestPackages["QAP_FLOWER"] = "QualityAssurancePackageFlower";
    TestPackages["HCP_FLOWER"] = "HealthCanadaPackageFlower";
    TestPackages["CTP_FLOWER"] = "CompleteTestingPackageFlower";
    TestPackages["QAP_OIL"] = "QualityAssurancePackageOil";
    TestPackages["HCP_OIL"] = "HealthCanadaPackageOil";
    TestPackages["CTP_OIL"] = "CompleteTestingPackageOil";
    TestPackages["QAP_HYBRID"] = "QualityAssurancePackageHybrid";
    TestPackages["HCP_HYBRID"] = "HealthCanadaPackageHybrid";
    TestPackages["CTP_HYBRID"] = "CompleteTestingPackageHybrid";
    TestPackages["CUSTOM_FLOWER"] = "CustomPackageFlower";
    TestPackages["CUSTOM_OIL"] = "CustomPackageOil";
    TestPackages["CUSTOM_HYBRID"] = "CustomPackageHybrid";
})(TestPackages || (exports.TestPackages = TestPackages = {}));
var TurnaroundTime;
(function (TurnaroundTime) {
    TurnaroundTime["STANDARD"] = "StandardTAT";
    TurnaroundTime["RUSH"] = "RushTAT";
    TurnaroundTime["URGENT"] = "UrgentTAT";
})(TurnaroundTime || (exports.TurnaroundTime = TurnaroundTime = {}));
var FrontendTurnaroundTimeOptions;
(function (FrontendTurnaroundTimeOptions) {
    FrontendTurnaroundTimeOptions["STANDARD"] = "StandardTATDescription";
    FrontendTurnaroundTimeOptions["RUSH"] = "RushTATDescription";
    FrontendTurnaroundTimeOptions["URGENT"] = "UrgentTATDescription";
    FrontendTurnaroundTimeOptions["CUSTOM"] = "CustomTATDescription";
})(FrontendTurnaroundTimeOptions || (exports.FrontendTurnaroundTimeOptions = FrontendTurnaroundTimeOptions = {}));
var TestStatus;
(function (TestStatus) {
    TestStatus["INCOMPLETE_REQUEST"] = "Incomplete Request";
    TestStatus["REQUEST_SUBMITTED"] = "Request Submitted";
    TestStatus["SAMPLE_REGISTERED"] = "Sample Registered";
    TestStatus["REPORT_READY"] = "Report Ready";
})(TestStatus || (exports.TestStatus = TestStatus = {}));
// export enum ProductStatus {
// 	AWAIT_ARRIVAL = "Await arrival",
// 	PROCESSING = "Processing",
// 	ON_HOLD = "On Hold",
// 	PACKING = "Packing",
// 	SHIPPED = "Shipped",
// }
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["INCOMPLETE"] = "Incomplete";
    OrderStatus["PENDING"] = "Pending";
    OrderStatus["IN_PROGRESS"] = "In Progress";
    OrderStatus["SHIPPED"] = "Shipped";
    OrderStatus["DELIVERED"] = "Delivered";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var AdminViewOrderStatus;
(function (AdminViewOrderStatus) {
    AdminViewOrderStatus["UNPAID"] = "Unpaid";
    AdminViewOrderStatus["PAID"] = "Paid";
    AdminViewOrderStatus["IN_PROGRESS"] = "In Progress";
    AdminViewOrderStatus["SHIPPED"] = "Shipped";
    AdminViewOrderStatus["DELIVERED"] = "Delivered";
})(AdminViewOrderStatus || (exports.AdminViewOrderStatus = AdminViewOrderStatus = {}));
var FrontendContentPage;
(function (FrontendContentPage) {
    FrontendContentPage["NEW_ORDER_PAGE"] = "NewOrderPage";
    FrontendContentPage["VIEW_ORDER_PAGE"] = "ViewOrderPage";
    FrontendContentPage["USER_INFO_PAGE"] = "UserInfoPage";
    FrontendContentPage["HELP_PAGE"] = "HelpPage";
    //admins
    FrontendContentPage["ROSTER_PAGE"] = "RosterPage";
    FrontendContentPage["ORGANIZATION_PAGE"] = "OrganizationPage";
    //??
    FrontendContentPage["VIEW_SUBMISSION_PAGE"] = "ViewSubmissionPage";
})(FrontendContentPage || (exports.FrontendContentPage = FrontendContentPage = {}));
var FrontendTestOptionTab;
(function (FrontendTestOptionTab) {
    FrontendTestOptionTab["CHEMICAL"] = "Chemical";
    FrontendTestOptionTab["MICRO"] = "Micro";
    FrontendTestOptionTab["ADDITIONAL"] = "Additional";
})(FrontendTestOptionTab || (exports.FrontendTestOptionTab = FrontendTestOptionTab = {}));
var FrontendProfileTab;
(function (FrontendProfileTab) {
    FrontendProfileTab["PROFILE"] = "Profile";
    FrontendProfileTab["LICENSE"] = "License";
    FrontendProfileTab["BILLING"] = "Billing";
    FrontendProfileTab["SPECIFICATIONS"] = "Specifications";
})(FrontendProfileTab || (exports.FrontendProfileTab = FrontendProfileTab = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["ML"] = "ml";
    WeightUnit["GRAMS"] = "g";
})(WeightUnit || (exports.WeightUnit = WeightUnit = {}));
var DBAction;
(function (DBAction) {
    DBAction["INSERT"] = "insert";
    DBAction["UPDATE"] = "update";
    DBAction["DELETE"] = "delete";
    DBAction["UPSERT"] = "upsert";
})(DBAction || (exports.DBAction = DBAction = {}));
var LicenseOption;
(function (LicenseOption) {
    LicenseOption["SELECT_LICENSE"] = "SelectLicense";
    LicenseOption["ADD_LICENSE"] = "AddLicense";
    LicenseOption["NO_LICENSE"] = "NoLicense";
})(LicenseOption || (exports.LicenseOption = LicenseOption = {}));
var LicenseDesignation;
(function (LicenseDesignation) {
    LicenseDesignation["MEDICAL"] = "Medical";
    LicenseDesignation["ADULT_USE"] = "AdultUse";
    LicenseDesignation["HEMP"] = "Hemp";
    LicenseDesignation["OTHER"] = "Other";
})(LicenseDesignation || (exports.LicenseDesignation = LicenseDesignation = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType["LICENSED_PRODUCER"] = "LicensedProducer";
    LicenseType["MICRO_CULTIVATOR"] = "MicroCultivator";
    LicenseType["PERSONAL_MEDICAL_USE"] = "PersonalMedicalUse";
    LicenseType["RETAILER"] = "Retailer";
    LicenseType["LICENSED_PROCESSOR"] = "LicensedProcessor";
    LicenseType["OTHER"] = "Other";
})(LicenseType || (exports.LicenseType = LicenseType = {}));
var Severity;
(function (Severity) {
    Severity["SUCCESS"] = "success";
    Severity["ERROR"] = "error";
    Severity["INFO"] = "info";
    Severity["WARN"] = "warning";
})(Severity || (exports.Severity = Severity = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["VALIDATING_EMAIL"] = "validating-email";
    UserStatus["REGISTERED"] = "registered";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["PENDING"] = "pending";
    ApprovalStatus["APPROVED"] = "approved";
    ApprovalStatus["REJECTED"] = "rejected";
})(ApprovalStatus || (exports.ApprovalStatus = ApprovalStatus = {}));
var InstallFamiliarizeOptions;
(function (InstallFamiliarizeOptions) {
    InstallFamiliarizeOptions["ON_SITE"] = "OnSite";
    InstallFamiliarizeOptions["REMOTE"] = "Remote";
})(InstallFamiliarizeOptions || (exports.InstallFamiliarizeOptions = InstallFamiliarizeOptions = {}));
var RepairOptions;
(function (RepairOptions) {
    RepairOptions["REPAIRS"] = "Repairs";
    RepairOptions["REPAIRACCESSMENT"] = "RepairAccessment";
})(RepairOptions || (exports.RepairOptions = RepairOptions = {}));
var ServicePackages;
(function (ServicePackages) {
    ServicePackages["CUSTOM"] = "Custom";
})(ServicePackages || (exports.ServicePackages = ServicePackages = {}));
var OrderItemType;
(function (OrderItemType) {
    OrderItemType["INSTRUMENT"] = "Instrument";
    OrderItemType["SERVICE"] = "Service";
})(OrderItemType || (exports.OrderItemType = OrderItemType = {}));
var OrderType;
(function (OrderType) {
    OrderType["INSTRUMENT"] = "Instrument";
    OrderType["SERVICE"] = "Service";
})(OrderType || (exports.OrderType = OrderType = {}));
var WarrantyUnit;
(function (WarrantyUnit) {
    WarrantyUnit["DAY"] = "day";
    WarrantyUnit["MONTH"] = "month";
    WarrantyUnit["YEAR"] = "year";
})(WarrantyUnit || (exports.WarrantyUnit = WarrantyUnit = {}));
var DiscountUnit;
(function (DiscountUnit) {
    DiscountUnit["NUMBER"] = "$";
    DiscountUnit["PERCENTAGE"] = "%";
})(DiscountUnit || (exports.DiscountUnit = DiscountUnit = {}));
var TaxOptions;
(function (TaxOptions) {
    TaxOptions["ZERO"] = "0";
    TaxOptions["EXCLUDED"] = "excluded";
    TaxOptions["OTHER"] = "other";
})(TaxOptions || (exports.TaxOptions = TaxOptions = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PAYINFULL"] = "PayInFull";
    PaymentStatus["PURCHASEORDER"] = "PO";
    PaymentStatus["DOWNPAYMENT"] = "Downpayment";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var EngineerDocumentType;
(function (EngineerDocumentType) {
    EngineerDocumentType["CHECKLIST"] = "Checklist";
    EngineerDocumentType["WORKORDER"] = "WorkOrder";
})(EngineerDocumentType || (exports.EngineerDocumentType = EngineerDocumentType = {}));
